<template>
  <div class="border">
    <!-- <div class="name">{{ cocktail.name }}
      <div class="alc" v-if="cocktail.alcohols">Alc</div>
    </div> -->
    <!-- <my-input v-model="cocktail.name"/> -->
    <div style="display: flex; align-items: center;">
      <input class="text_ingr" v-model="cocktail.name"/>

      <input v-model="cocktail.alcohols" type="checkbox" id="alc" style="margin-left: auto;"/>
      <label class="alc" for="alc">Alc</label>

      <input v-model="cocktail.active" type="checkbox" id="active" style="margin-left: 25px;"/>
      <label class="alc" for="active">Active</label>

      <!-- <button class="btn_close" @click="close()">×</button> -->
      <button class="btn_close" @click="close()">&times;</button>
    </div>

    <div style="margin-top: 25px;">
      <div class="ingrs" v-for="(ingr, index) in cocktail.ingredients">
        <!-- {{ ingr }} -->
        <input class="text_ingr" v-model="ingr[0]"/>
        <input class="text_ingr" v-model="ingr[1]"/>
        <input class="text_ingr" v-model="ingr[2]"/>
        <button class="del_btn" @click="del_ingr(index)">×</button>
      </div>
      <div>
        <my-button class="btn_green" @click="new_ingr()">+</my-button>
        <!-- <button class="btn_green">+</button> -->
      </div>
    </div>

    <div>
      <my-button class="send_btn" @click="send_cocktail()" ref="sendBtn">send</my-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cocktailID: {
      type: Number,
      required: true, // обязательно
    }
  },
  data() {
    return {
      cocktail: {},
      delAlredy: false,
    }
  },
  methods: {
    async change_order_status(status) {
      let res = await fetch("/api/barman/order_status", {
        method: "POST",
        headers: {"content-type": "application/json"},
        body: JSON.stringify({
          order_id: this.order.order_id,
          status: status
        })
      })
      if (res.status === 200) {
        let answer = await res.json();
        this.order.status = answer.order_status;
      }
    },
    async order_del_cocktail() {
      if (this.delAlredy === false) {
        this.delAlredy = true;
      } else if (this.delAlredy === true) {
        let res = await fetch("/api/barman/order_del", {
          method: "POST",
          headers: {"content-type": "application/json"},
          body: JSON.stringify({order_id: this.order.order_id})
        })
        if (res.status === 200) {
          let answer = await res.json();
          this.close();
        }
      }
    },
    async get_cocktail_by_id() {
      let res = await fetch(`/api/barman/cocktail/${this.cocktailID}`, {
        method: "POST",
        headers: {"content-type": "application/json"}
      })
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data);
        this.cocktail = data.cocktail;
      }
    },
    new_ingr() {
      this.cocktail.ingredients.push(['', '', ''])
    },
    del_ingr(index) {
      // console.log(index);
      let item = this.cocktail.ingredients.splice(index, 1);
      // console.log(index, item);
    },
    async send_cocktail() {
      let res = await fetch(`/api/barman/update_cocktail`, {
        method: "POST",
        headers: {"content-type": "application/json"},
        body: JSON.stringify(this.cocktail)
      })
      if (res.status === 200) {
        let data = await res.json();
        let btn = this.$refs.sendBtn.$el
        btn.classList.add('success-animation');
        setTimeout(() => btn.classList.remove('success-animation'), 1000)
        // console.log(data);
        this.$emit('updateCocktails');
      }
    },
    close() {
      this.$emit('hideEvent');
    }
  },
  mounted() {
    this.get_cocktail_by_id();
  }
}
</script>

<style scoped>
.border {
  display: block;
  /* display: flex; */
  /* flex-direction: column; */
  /* margin-top: 15px; */
  padding: 5px;
  border: 6px solid var(--bar-color-main);
  border-radius: 15px;
}
.name {
  display: flex;
  color: black;
  font-size: 40px;
  padding: 25px;
  /* align-self: center; */
  /* align-content: center; */
  align-items: center;
}
.alc {
  margin-left: 5px;
  color: HotPink;
  font-size: 40px;
}
.ingr {
  color: black;
  font-size: 30px;
}

.btn_circle {
  aspect-ratio: 1 / 1;
}

.btn_close {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  margin-left: auto;
  /* position: relative; */
  width: 45px;
  height: 45px;
  border: 3px solid var(--bar-color-main);
  border-radius: 50%;
  background-color: white;
}
.btn_close:active {
  background-color: var(--bar-color-active);
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
}

.ingrs {
  display: flex;
  gap: 5px;
  margin-top: 10px;
  align-items: center;
}
.text_ingr {
  display: block;
  /* width: 50%; */
  /* width: fit-content; */
  min-width: 1px;
  max-width: 99%;
  /* font-size: 15px; */
  outline: none;
}
.text_ingr:focus {
  border: 2px solid var(--bar-color-light);
  border-radius: 2px;
}

.btn_green {
  /* width: auto; */
  /* font-size: 35px; */
  width: 100%;
  padding: 0px;
  border: 5px solid lightgreen;
}
.del_btn {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;

  aspect-ratio: 1 / 1;
  height: 35px;
  /* width: 35px; */
  /* min-width: 35px; */

  color: red;
  background-color: transparent;
  border: 2px solid red;
  border-radius: 50%;
}
.send_btn {
  margin-top: 35px;
  width: 100%;
  transition: border 1s ease-in-out;
}


.success-animation {
  /* animation: pulse 2s infinite; */
  animation: pulse 2s 1;
  border: 5px solid lightgreen;
}
@keyframes pulse {
  0% {box-shadow: 0 0 0 0 lightgreen;}
  70% {box-shadow: 0 0 0 10px rgba(144, 238, 144, 0);}
  100% {box-shadow: 0 0 0 0 rgba(144, 238, 144, 0);}
}




</style>
